import clsx from "clsx";

import BaseModalTransition from "../components/BaseModalTransition";
import { Close } from "nvs-ds-icons/react/navigation";
import { IconButton } from "../../IconButton";
import { IconButtonType } from "../../IconButton/types";
import RoundedModalContainerWithTransition from "./components/RoundedModalContainerWithTransition";
import { CLOSE_ROUNDED_MODAL_BUTTON } from "./testIds";

export type Props = React.PropsWithChildren<{
  isOpen: boolean;
  onClose: () => void;
  showCloseButton?: boolean;
  className?: string;
}>;

const RoundedModal: React.FC<Props> = ({
  isOpen,
  onClose,
  className,
  children,
  showCloseButton = true,
}) => {
  return (
    <BaseModalTransition
      isOpen={isOpen}
      onClose={onClose}
      backgroundClassName={"bg-gray-950 bg-opacity-75"}
    >
      <div className="fixed inset-0 w-screen overflow-y-auto z-modal">
        <div className="flex min-h-full items-end justify-center md:items-center">
          <RoundedModalContainerWithTransition className={className}>
            {showCloseButton && (
              <IconButton
                buttonType={IconButtonType.no_outline}
                onClick={() => onClose()}
                aria-label={"Close Modal"}
                data-testid={CLOSE_ROUNDED_MODAL_BUTTON}
                className={clsx("absolute top-5 right-5")}
              >
                <Close />
              </IconButton>
            )}
            {children}
          </RoundedModalContainerWithTransition>
        </div>
      </div>
    </BaseModalTransition>
  );
};

export default RoundedModal;
